// Build-time configuration (CONTRACT section 10). Defaults are production so a plain
// `vite build` is deployable; Deploy-Console.ps1 still passes them explicitly.
function positiveInt(raw: string | undefined, fallback: number): number {
  const n = Number(raw);
  return raw && Number.isInteger(n) && n > 0 ? n : fallback;
}

export const env = {
  iamIssuer: import.meta.env.VITE_IAM_ISSUER ?? 'https://auth.vipper.network/oidc',
  iamClientId: import.meta.env.VITE_IAM_CLIENT_ID ?? 'infrastructure-console',
  vpnApiBase: import.meta.env.VITE_VPN_API_BASE ?? 'https://vpn-api.vipper.network/api/v1',
  // The relay agent's idle timeout (vpn/variables.tf relay_idle_timeout_minutes). The API does
  // not report it, so the Overview's "idle stop in" countdown needs it here.
  relayIdleMinutes: positiveInt(import.meta.env.VITE_RELAY_IDLE_MINUTES, 30),
};
